import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CardContent, Typography } from '@mui/material';
import { MedicalServices as MedNecIcon } from '@mui/icons-material';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { MedNecDashboardBackButton } from '../CaseForm/actions';
import MedNecWorklistGrid from './MedNecWorklistGrid';
import { ACTIVE_STATUSES, getStatusConfig, type MedNecStatus } from '../utils/statusConfig';

const MedNecWorklist: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';
  const statusParam = searchParams.get('status') || '';

  const validStatus: MedNecStatus = ACTIVE_STATUSES.includes(statusParam as MedNecStatus)
    ? (statusParam as MedNecStatus)
    : 'Pending';

  if (!company || !center || !statusParam) {
    return (
      <PageContainer>
        <Box display="flex" justifyContent="center">
          <PageCard sx={{ maxWidth: 800 }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="error">
                Missing required parameters. Please specify company, center, and status to view the case worklist.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#64748b' }}>
                Company: {company || 'Not specified'} | Center: {center || 'Not specified'} | Status: {statusParam || 'Not specified'}
              </Typography>
            </CardContent>
          </PageCard>
        </Box>
      </PageContainer>
    );
  }

  const displayName = getStatusConfig(validStatus).displayName;

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Header */}
          <Box sx={{
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <MedNecIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
              <Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 600, color: '#1e293b', mb: 0.5 }}
                >
                  {displayName} Cases
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  {company} | {center}
                </Typography>
              </Box>
            </Box>
            <MedNecDashboardBackButton company={company} center={center} />
          </Box>

          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <MedNecWorklistGrid />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default MedNecWorklist;
